import React, {Component} from "react";
import DateUtil from "../../../../../utils/DateUtil";
import EligibilityStatusEnum from "../../../../insurance/enums/EligibilityStatusEnum";
import InsuranceReferralStatus from "../../../../insurance/enums/InsuranceReferralStatus";
import DirectBillingReferralTypeEnum from "../../../../insurance/enums/DirectBillingReferralTypeEnum";
import RemotingService from "../../../../../services/remoting-service/RemotingService";
import ProcedureViewHistory from "./ProcedureViewHistory";
import HoverableDescriptionBox from "../../../../../components/hoverable-desc-box/HoverableDescriptionBox";
import {isEmpty} from "../../../../../utils/ArrayUtil";
import DiagnosisUtil from "../../diagnosis/DiagnosisUtil";

export default class BillingViewHistory extends Component {

    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        this.retrieveInsuranceApproval();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.visit.id !== this.props.visit.id) {
            this.retrieveInsuranceApproval();
        }
    }

    retrieveInsuranceApproval() {
        RemotingService.getRemoteCall(
            `api/insurance/coordinator/v2/insurance-approval/visit/${this.props.visit.id}`,
            null,
            insuranceApproval => {
                this.setState({insuranceApproval});
            });
    }

    renderSessionsTable() {
        const directBilling = this.state.insuranceApproval?.directBilling;
        const items = directBilling?.items;
        if (!items || items.length === 0) return null;

        return (
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px' }}>
                <tbody>
                    {items.map((item, index) => (
                        <tr key={index} style={{ borderBottom: index < items.length - 1 ? '1px solid #eee' : 'none' }}>
                            <td style={{ padding: '2px 6px', fontWeight: 600, width: '1%', whiteSpace: 'nowrap' }}>{item.cpt?.cptCode || '-'}</td>
                            <td style={{ padding: '2px 6px', textAlign: 'left' }}>
                                {DiagnosisUtil.directBillingSessionLabel(this.state.insuranceApproval, item)}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        );
    }

    renderDiagnosisGroups() {
        const directBilling = this.state.insuranceApproval?.directBilling;

        if (!directBilling || !directBilling.diagnosisGroup || !directBilling.diagnosisGroup.diagnosisItems || directBilling.diagnosisGroup.diagnosisItems.length === 0) {
            return null;
        }

        const sortedItems = [...directBilling.diagnosisGroup.diagnosisItems].sort((a, b) => {
            if (a.level === "PRINCIPAL" && b.level !== "PRINCIPAL") return -1;
            if (a.level !== "PRINCIPAL" && b.level === "PRINCIPAL") return 1;
            return 0;
        });

        return (
            <div className="diagnosis-group-container">
                {sortedItems.map((item, index) => {
                    const prefix = item.level === "PRINCIPAL" ? "P: " : "S: ";
                    const header = `${prefix}${item.code}`;

                    return (
                        <HoverableDescriptionBox
                            key={index}
                            header={header}
                            description={item.description}
                        />
                    );
                })}
            </div>
        );
    }

    render() {
        const {directBillingProcedures, selfPayProcedures} = this.props.diagnosis;
        const {insuranceApproval} = this.state;
        const directBilling = insuranceApproval?.directBilling;

        if (!insuranceApproval && isEmpty(directBillingProcedures) && isEmpty(selfPayProcedures)) {
            return <div className="pl-3">No information available</div>
        }

        return (
            <>
                {insuranceApproval &&
                <div className="pl-3">
                    <div className="row">
                        <div className={"col-6"}>
                            <div className="row no-padding no-margin">
                                <div className={"col-3 dim14-form-label pl-0"}>
                                    Provider:
                                </div>
                                <div className={"col-9"}>
                                    {insuranceApproval?.provider}
                                </div>
                            </div>
                        </div>
                        <div className={"col-6"}>
                            <div className="row no-padding no-margin">
                                <div className={"col-5 dim14-form-label"}>
                                    Referring Physician:
                                </div>
                                <div className={"col-7"}>
                                    {directBilling?.referrerName || ''}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className={"col-sm-4 dim14-form-label"}>Insurance Status:</div>
                        <div className={"col-sm-8 overflow-wrap-anywhere"}>
                            {EligibilityStatusEnum[insuranceApproval.eligibilityStatus]?.name}
                        </div>
                    </div>
                    <div className="row">
                        <div className={"col-sm-4 dim14-form-label"}>Reference No:</div>
                        <div className={"col-sm-8 overflow-wrap-anywhere"}>
                            {directBilling?.referenceNo || ''}
                        </div>
                    </div>
                    <div className="row">
                        <div className={"col-sm-4 dim14-form-label"}>Diagnosis:</div>
                        <div className={"col-sm-8 overflow-wrap-anywhere"}>
                            {this.renderDiagnosisGroups()}
                        </div>
                    </div>
                    <div className="row">
                        <div className={"col-sm-4 dim14-form-label"}>Claim Status:</div>
                        <div className={"col-sm-8 overflow-wrap-anywhere"}>
                            {directBilling && DirectBillingReferralTypeEnum[directBilling.referralType] === DirectBillingReferralTypeEnum.INTERNAL && 'Direct Billing: '}
                            {directBilling && DirectBillingReferralTypeEnum[directBilling.referralType] === DirectBillingReferralTypeEnum.EXTERNAL && 'External Referral: '}
                            {directBilling && directBilling.status ? InsuranceReferralStatus[directBilling.status].name : ''}
                        </div>
                    </div>
                    <div className="row">
                        <div className={"col-sm-4 dim14-form-label"}>Sessions:</div>
                        <div className={"col-sm-8 overflow-wrap-anywhere"}>
                            {this.renderSessionsTable()}
                        </div>
                    </div>
                    <div className="row">
                        <div className={"col-sm-4 dim14-form-label"}>Validity:</div>
                        <div className={"col-sm-8 overflow-wrap-anywhere"}>
                            {directBilling && directBilling.validUntil ?
                                DateUtil.formatDate(directBilling.validUntil, 'Do MMM YYYY') : ''}
                        </div>
                    </div>
                </div>
                }
                <div>
                    {directBillingProcedures && directBillingProcedures.length > 0 &&
                    <ProcedureViewHistory billType="Direct Billing"
                                          procedures={directBillingProcedures}
                                          visit={this.props.visit}
                                          insurance={this.props.insurance}/>
                    }
                    {selfPayProcedures && selfPayProcedures.length > 0 &&
                    <ProcedureViewHistory billType="Self Pay"
                                          procedures={selfPayProcedures}
                                          visit={this.props.visit}
                                          insurance={this.props.insurance}/>
                    }
                </div>
            </>
        );
    }
}
